import * as type from './types';

export function storeBusiness(data) {
    return {
      type: type.REGISTER_STORE_BUSINESS_REQUESTED,
      data:data,
    }
  }